<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Providers'"
        :buttons="[
          {
            title: 'Add Provider',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'Providers2'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @cellClicked="rowClicked($event)"
        :addContextMenuItem="getContextMenuItems"
      ></dataTable>
      <upsert
        v-if="addShow || updateShow != null"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
      <modal
        :title="'Customer ' + openCustomerProviderLogs.Name + ' Provider Logs'"
        @close="openCustomerProviderLogs = null"
        v-if="openCustomerProviderLogs != null"
        size="xl"
      >
        <template #content>
          <customerProviderLogs
            :providerId="openCustomerProviderLogs.Id"
          ></customerProviderLogs>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
import customerProviderLogs from "./../customerProvidersLogs/list.vue";
export default {
  name: "Providers",
  components: { upsert, customerProviderLogs },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Load",
          field: "Load",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "State",
          field: "State",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Confirm",
          field: "Confirm",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Notconfirm",
          field: "Notconfirm",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Download",
          field: "Download",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "TourPrice",
          field: "TourPrice",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "NotedConfirm",
          field: "NotedConfirm",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "IsMailProvider",
          field: "IsMailProvider",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Stopped",
          field: "Stopped",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "CaptchaService",
          field: "CaptchaService",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P1",
          field: "P1",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P2",
          field: "P2",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P3",
          field: "P3",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "OutputPort",
          field: "OutputPort",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Link",
          field: "Link",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          cellRenderer: function(event) {
            return (
              "<a target='_blank' href='" +
              event.value +
              "'>" +
              event.value +
              "</a>"
            );
          },
        },
        {
          headerName: "SiteKey",
          field: "SiteKey",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "1. Logo",
          field: "Name2",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          cellRenderer: function(event) {
            return (
              "<img src='https://client.naps.com.tr/provider/" +
              (event.data.Name=="Holiday+"?"Holidayplus":event.data.Name) +
              ".png' style='height:29px; margin-top: -2px;'/>"
            );
          },
        },
        {
          headerName: "2. Logo",
          field: "Name3",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          cellRenderer: function(event) {
            return (
              "<img src='https://resbox.com/offer/img/extranet/" +
              (event.data.Name=="Holiday+"?"Holidayplus":event.data.Name) +
              ".png' style='height:29px; margin-top: -2px;'/>"
            );
          },
        },
        {
          headerName: "RedisTTL",
          field: "RedisTTL",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(e) {
            return e.value == null ? "-" : e.value;
          },
        },
        {
          headerName: "OnTest",
          field: "OnTest",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "WorkingStatus",
          field: "WorkingStatus",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(e) {
            if (e.value == null) return "-";
            if (e.value == 1) return "Normal";
            if (e.value == 2) return "Yavaş";
            return e.value;
          },
        },
        {
          headerName: "ConfirmStatus",
          field: "ConfirmStatus",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "DocumentStatus",
          field: "DocumentStatus",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
      ],
      data: null,
      addShow: false,
      updateShow: null,
      openCustomerProviderLogs: null,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`kolayrez/Providers`).then((response) => {
      this.data = response.data;
    });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the provider named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`KOLAYREZ/Providers/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Provider was deleted successfully.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    rowClicked(item) {
      if (item.colDef.field != "Link") {
        this.updateShow = item?.data;
      }
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Update",
          icon: "<i class='fas fa-pencil-alt'></i>",
          action: () => {
            this.updateShow = params.node.data;
          },
        },
        {
          name: "Customer Provider Logs",
          icon: '<i class="far fa-question-circle"></i>',
          action: () => {
            this.openCustomerProviderLogs = params.node.data;
          },
        },
        {
          name: "Remove",
          icon: "<i class='fas fa-trash-alt'></i>",
          action: () => {
            this.remove(params.node.data);
          },
        },
      ];
      return result;
    },
  },
};
</script>
